import { UseMutationResult } from '@tanstack/react-query'
import { graphql } from 'src/gql'
import { MutateVoidEeocByCandidateMutation, MutateVoidEeocByCandidateMutationVariables } from 'src/gql/graphql'
import { useGraphMutation } from 'src/hooks/useGraphMutation'
import { useInvalidateQueryByDocument, useResetQuery } from 'src/hooks/useGraphQL'
import { candidateCreatedUpdatedByIdDocument } from '../../candidate/useCandidateCreatedUpdatedById'
import { eeocByCandidateDocument } from '../useEeocByCandidate'

const document = graphql(/* graphql */`
  mutation mutateVoidEeocByCandidate($candidate: MongoID!, $voidReason: String!) {
    cat {
      eeoc {
        voidEeocByCandidate(candidate: $candidate, voidReason: $voidReason) {
          _id
          candidate
        }
      }
    }
  }
`)

export type UseMutateVoidEeocByCandidateReturn = UseMutationResult<
MutateVoidEeocByCandidateMutation,
unknown,
MutateVoidEeocByCandidateMutationVariables
>

const useMutateVoidEeocByCandidate = (): UseMutateVoidEeocByCandidateReturn => {
  const invalidateCreatedUpdated = useInvalidateQueryByDocument(candidateCreatedUpdatedByIdDocument)
  const resetEeoc = useResetQuery(eeocByCandidateDocument)
  return useGraphMutation(document, {
    onSuccess: (data) => {
      const id = data.cat?.eeoc?.voidEeocByCandidate?.candidate
      if (typeof id === 'string') {
        void invalidateCreatedUpdated({ id })
        void resetEeoc({ candidate: id })
      }
    }
  })
}

export { useMutateVoidEeocByCandidate, document as mutateVoidEeocByCandidateDocument }
